import { default as role } from './role/routes'

export default [
    ...role,
    {
        path: '/roles',
        name: 'roleIndex',
        component: () => import ('./pages/Index')
    }
]